import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  DatePicker,
  Table,
  Typography,
  Divider,
  Tooltip,
  Tag,
  Tabs,
  Spin,
  Popconfirm,
  Space,
  Modal,
} from "antd";
import moment from "moment";
import Page from "_components/Page";
import {
  companyService,
  materialTypeService,
  materialRequestService,
  materialDetailService,
  measurementTypeService,
  storageUnitService,
} from "_services";
import {
  CheckOutlined,
  DeleteOutlined,
  SearchOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import StockSelection from "./StockSelection";
import { Utils } from "_helpers";
import TabMenu from "./TabMenu";

let lineIndex = 0;

function Verify({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [stockItemLoading, setStockItemLoading] = useState(false);
  const [availableStocksLoading, setIsAvailableStocksLoading] = useState(false);
  const [loadingCompleteVerification, setLoadingCompleteVerification] =
    useState(false);
  const [loadingAllocationUpdate, setLoadingAllocationUpdate] = useState(false);
  const [loadingStatusUpdate, setLoadingStatusUpdate] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);
  const [materialRequest, setMaterialRequest] = useState({});
  const [materialRequestLines, setMaterialRequestLines] = useState([]);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [allocatedItems, setAllocatedItems] = useState([]);

  const [availableStocks, setAvailableStocks] = useState([]);
  const [isStockSelectionVisible, setIsStockSelectionVisible] = useState(false);
  const [selectedStockIds, setSelectedStockIds] = useState([]);
  const [selectedStockTypeId, setSelectedStockTypeId] = useState(null);
  const [selectedLineKey, setSelectedLineKey] = useState(null);
  const [selectedMrLineKeys, setSelectedMrLineKeys] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState(null);
  const [activeRequestLine, setActiveRequestLine] = useState(null);
  const [enableVerify, setEnableVerify] = useState(false);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();

  const { Option } = Select;
  const { Text } = Typography;
  const { TextArea } = Input;

  useEffect(() => {
    const fetchAlldatas = async () => {
      setLoading(true);
      const customerData = await companyService.getSuggestion(
        "?companyType=CUSTOMER"
      );
      const materialTypeData = await materialTypeService.getSuggestion();
      const measurementTypeData = await measurementTypeService.getSuggestion();
      const materialRequestData = await materialRequestService.getById(id);

      if (materialRequestData) {
        let materialRequest = materialRequestData.content;
        if (materialRequest.orderStage !== "VERIFICATION") {
          history.push(`/material-requests/${materialRequest.id}/summary`);
        }
        materialRequest.requestDate = moment(materialRequest.requestDate);
        materialRequest.requestLines.forEach((item, i) => {
          item.key = item.id;
        });
        const mrCustomer = await companyService.getById(
          materialRequest.customer.id
        );
        /* const officeAddresses = mrCustomer.content.addresses.filter(
          (item) => item.addressType === "OFFICE"
        ); */

        materialRequest.requestLines.forEach((line) => {
          line.stockTypeObj = line.stockType;
          lineIndex++;
        });
        // console.log("MR:", materialRequest);
        setAllocatedItems([
          ...allocatedItems,
          ...materialRequest.requestLines
            .flatMap((item) => item.requestedItemsByPallets ?? [])
            .filter((item) => item.mode === "ALLOCATED"),
        ]);
        setMaterialRequest(materialRequest);
        setMaterialRequestLines([].concat(materialRequest.requestLines));
        setAddresses(mrCustomer.content.addresses);
        onFill(materialRequest);
        if (activeTabKey === null && materialRequest.requestLines) {
          handleTabChange(materialRequest.requestLines[0].key);
        }
      }

      setCustomers(customerData.content);
      setMaterialTypes(materialTypeData.content);
      setMeasurementTypes(measurementTypeData.content);
      setLoading(false);
    };

    fetchAlldatas();
  }, []);

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const validateRequestLines = (lines) => {
    let validLines = true;
    if (lines && lines.length > 0) {
      lines.forEach((line) => {
        if (!line.stockType || !line.quantity || !line.quantity > 0) {
          validLines = false;
        }
      });
    }
    return validLines;
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        //if (validateRequestLines(values.requestLines)) {
        setUpdating(true);
        // console.log(", requestLines:", materialRequestLines);

        values.requestDate = moment(values.requestDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        values.requestLines = materialRequestLines.map((line) => ({
          id: line.id,
          stockType: { id: line.stockType.id },
          requestTime: line.requestTime,
          //quantity: line.quantity || line.netWeight || line.qty,
          quantity: line.totalItems,
          totalItems: line.totalItems,
          measurementType: { id: line.measurementType.id },
          requestedItems: line.requestedItems.map((item) => ({
            id: item.id,
          })),
        }));
        //console.log("MR: ", JSON.stringify(values));

        materialRequestService
          .update(materialRequest.id, values)
          .then(() => {
            setUpdating(false);
            message.success("Successfully updated!");
            //history.push(`${path}`.replace(":id", id));
            window.location.reload();
            setEnableVerify(false);
          })
          .catch((error) => {
            setUpdating(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const validateVerifiationCompletion = () => {
    let validation = true;
    materialRequestLines.forEach((line) => {
      if (
        line.requestedItems.length === 0 ||
        line.totalItems > line.requestedItems.length ||
        line.quantity >
          line.requestedItems
            .map((item) => item.quantity)
            .reduce((prev, next) => prev + next)
      ) {
        validation = false;
      }
    });

    return validation;
  };

  const onCompleteVerification = () => {
    // Removed validation as per request
    if (validateVerifiationCompletion()) {
      setLoadingCompleteVerification(true);
      const payload = {
        orderStage: "PREPARE",
      };
      materialRequestService
        .updateStatus(materialRequest.id, payload)
        .then(() => {
          setLoadingCompleteVerification(false);
          message.success("Successfully completed verificaiton!");
          history.push(`/material-requests/${id}/summary`);
        })
        .catch((error) => {
          setLoadingCompleteVerification(false);
          message.error(`${error}`);
        });
    } else {
      message.error("Sorry, some of the request lines are not yet verified!");
    }
  };

  const onCancel = () => {
    history.push("/material-requests");
  };

  const handleStockItemUnVerified = (stockItemId) => {
    setLoadingAllocationUpdate(true);
    const allocationnUpdatePayload = {
      refId: materialRequest.id,
      type: "REQUEST",
      isCancelled: 1,
      stockItems: [
        { id: stockItemId, requestedLine: { id: activeRequestLine.id } },
      ],
    };
    materialDetailService
      .updateAllocatedItems(allocationnUpdatePayload)
      .then(() => {
        message.success("Successfully status changed!");
        setLoadingAllocationUpdate(false);
        window.location.reload();
      })
      .catch((error) => {
        setLoadingAllocationUpdate(false);
        setError(error);
      });
    /* materialRequestService
      .deleteLineItem(id, stockItemId)
      .then((x) => {
        setLoading(false);
        message.success("Successfully unverified!");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        message.error(`${error}`);
      }); */
  };

  const handleRequestLineUnVerified = (requestLineId) => {
    setLoading(true);
    materialRequestService
      .updateLine(id, requestLineId, { lineStage: "VERIFICATION_INPROGRESS" })
      .then((x) => {
        setLoading(false);
        message.success("Successfully unverified!");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  };

  const handleRequestLineVerified = (requestLineId) => {
    setLoading(true);
    materialRequestService
      .updateLine(id, requestLineId, { lineStage: "VERIFIED" })
      .then((x) => {
        setLoading(false);
        message.success("Successfully verified!");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  };

  const handleRequestLineDelete = (requestLineId) => {
    setLoading(true);
    materialRequestService
      .deleteLine(id, requestLineId)
      .then((x) => {
        setLoading(false);
        message.success("Successfully deleted!");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  };

  const handleAllocationUpdate = () => {
    setLoadingAllocationUpdate(true);
    const allocationUpdatePayload = {
      refId: materialRequest.id,
      type: "REQUEST",
      palletSummaryDataList: allocatedItems
        .filter((item) => item.mode === "AVAILABLE")
        .map((item) => ({
          requestLineId: item.requestedLine.id,
          stockTypeId: item.stockTypeId,
          stockBinId: item.stockBinId,
          palletNumber: item.palletNo,
          assignQuantity: item.assignQuantity,
        })),
    };
    materialDetailService
      .updateAllocatedItems(allocationUpdatePayload)
      .then(() => {
        message.success("Stock allocation successfully!");
        setLoadingAllocationUpdate(false);
        window.location.reload();
      })
      .catch((error) => {
        setLoadingAllocationUpdate(false);
        setError(error);
      });
  };

  const handleStatusUpdate = () => {
    setLoadingStatusUpdate(true);
    const statusUpdatePayload = {
      requestStatus: "PREPARE",
    };
    materialRequestService
      .updateStatus(id, statusUpdatePayload)
      .then(() => {
        message.success("Successfully status changed!");
        setLoadingStatusUpdate(false);
        window.location.reload();
      })
      .catch((error) => {
        setLoadingStatusUpdate(false);
        setError(error);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    if (
      ["VERIFICATION"].includes(materialRequest && materialRequest.orderStage)
    ) {
      let statusButtonText = "Complete Allocation";
      buttons.push(
        <Popconfirm
          title={`Are you sure to ${statusButtonText} it?`}
          onConfirm={handleStatusUpdate}
          key="con-complete"
          disabled={
            allocatedItems.length === 0 ||
            allocatedItems.some((item) => item.mode === "AVAILABLE")
          }
        >
          <Button
            key="btn-complete"
            type="primary"
            htmlType="button"
            loading={loadingStatusUpdate}
            disabled={
              allocatedItems.length === 0 ||
              allocatedItems.some((item) => item.mode === "AVAILABLE")
            }
          >
            {statusButtonText}
          </Button>
        </Popconfirm>
      );
      buttons.push(
        <Popconfirm
          title="Are you sure to update the changes?"
          onConfirm={handleAllocationUpdate}
          key="scan-confirm"
          disabled={
            allocatedItems.filter((item) => item.mode === "AVAILABLE")
              .length === 0
          }
        >
          <Button
            key="scan"
            type="primary"
            loading={loadingAllocationUpdate}
            disabled={
              allocatedItems.filter((item) => item.mode === "AVAILABLE")
                .length === 0
            }
          >
            Update Allocation
          </Button>
        </Popconfirm>
      );

      /* buttons.push(
        <Popconfirm
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
          key="add-confirm"
          disabled={
            materialRequest &&
            materialRequest.requestLines.flatMap((item) => item.requestedItems)
              .length === 0
          }
        >
          <Button
            key="1"
            type="primary"
            htmlType="submit"
            loading={updating}
            disabled={
              materialRequest &&
              materialRequest.requestLines.flatMap(
                (item) => item.requestedItems
              ).length === 0
            }
          >
            Update
          </Button>
        </Popconfirm>
      ); */
      /* buttons.push(
        <Popconfirm
          title="Are you sure to complete verification?"
          onConfirm={onCompleteVerification}
          key="verify-success"
          disabled={!enableVerify}
        >
          <Button
            key="btn-verify-success"
            htmlType="submit"
            loading={loadingCompleteVerification}
            type="primary"
            disabled={!enableVerify}
          >
            Verified
          </Button>
        </Popconfirm>
      ); */
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Material",
      dataIndex: "stockType",
      key: "stockType",
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Measurements",
      key: "measurements",
      render: (text, record) => {
        if (!record.measurements || record.measurements.length === 0) {
          return "N/A";
        }

        return (
          <div>
            {record.measurements.map((measurement, index) => (
              <div key={index}>
                <strong>{measurement.measurementType.name}:</strong>{" "}
                {measurement.measurementValue}
              </div>
            ))}
          </div>
        );
      },
    });
    columns.push({
      title: "Veri. Pallets",
      key: "verifyPallets",
      align: "right",
      render: (text, record) => {
        return (
          record.requestedItemsByPallets &&
          record.requestedItemsByPallets.length
        );
      },
    });
    columns.push({
      title: "Veri. Quantity",
      key: "verifyQuantity",
      align: "right",
      render: (text, record) => {
        return (
          record.requestedItemsByPallets &&
          record.requestedItemsByPallets.length &&
          record.requestedItemsByPallets
            .map((item) => item.assignQuantity)
            .reduce((prev, next) => prev + next)
        );
      },
    });
    columns.push({
      title: "",
      key: "operation",
      render: (text, record) => {
        return (
          <Space size="small">
            <Button
              type="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleSearchAndAddStocks(record);
              }}
              icon={<SearchOutlined />}
              loading={availableStocksLoading && record.key === activeTabKey}
            >
              Stocks
            </Button>
          </Space>
        );
      },
    });

    return columns;
  };

  const getLineSummary = (pageData) => {
    const measurementTotals = {};
    let totalAssignStorageUnits = 0;
    let totalAssignQuanity = 0;

    pageData.forEach((line) => {
      if (line.measurements && line.measurements.length > 0) {
        line.measurements.forEach((measurement) => {
          const type = measurement.measurementType.name;
          const value = measurement.measurementValue;

          if (!measurementTotals[type]) {
            measurementTotals[type] = 0;
          }
          measurementTotals[type] += value;
        });
      }
      if (
        line.requestedItemsByPallets &&
        line.requestedItemsByPallets.length > 0
      ) {
        totalAssignStorageUnits += line.requestedItemsByPallets.length;
        totalAssignQuanity += line.requestedItemsByPallets
          .map((item) => item.assignQuantity)
          .reduce((prev, next) => prev + next);
      }
    });

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell colSpan={3}>
          <Text strong>Total</Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          <Text strong>
            {Object.entries(measurementTotals).map(([type, total]) => (
              <div key={type}>
                {type}: {total}
              </div>
            ))}
          </Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell align="right">
          {materialRequest.verifiedStorageUnits}
        </Table.Summary.Cell>
        <Table.Summary.Cell align="right">
          {materialRequest.verifiedPackages}
        </Table.Summary.Cell>
        <Table.Summary.Cell />
      </Table.Summary.Row>
    );
  };

  const getStockItemColumns = () => {
    let columns = [];
    columns.push({
      title: "Material Type",
      dataIndex: "stockType",
      key: "stockType",
      render: (text, record) => {
        return record.stockTypeCode;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockTypeName}>
            {record.stockTypeName}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Receipt Number",
      key: "receiptNumber",
      render: (text, record) => {
        return record.receiptNumber;
      },
    });
    columns.push({
      title: "Recv Date",
      dataIndex: "receivedDate",
      key: "receivedDate",
    });
    columns.push({
      title: "Pallet No",
      dataIndex: "palletNo",
      key: "palletNo",
    });
    columns.push({
      title: "Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      render: (text, record) => {
        return record.stockBinCode;
      },
    });
    columns.push({
      title: "Quantity",
      dataIndex: "totalItems",
      key: "totalItems",
      align: "right",
      render: (text, record) => {
        return text && Number(text);
      },
    });
    columns.push({
      title: "Assign Quantity",
      dataIndex: "assignQuantity",
      key: "assignQuantity",
      align: "right",
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "ALLOCATED") {
          color = "#2db7f5";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        if (text === "READY") {
          color = "#faad14";
        }
        if (text === "LOADED") {
          color = "#ffd666";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "",
      key: "action",
      render: (text, record) => {
        return (
          <span>
            {["VERIFICATION"].includes(materialRequest.orderStage) &&
              ["ALLOCATED"].includes(record.mode) && (
                <Popconfirm
                  title="Are you sure to unallocated this item?"
                  onConfirm={() => handleStockItemUnVerified(record.id)}
                >
                  <UndoOutlined title="Unallocate" />
                </Popconfirm>
              )}
          </span>
        );
      },
    });

    return columns;
  };

  const mrLineRowSelection = {
    selectedRowKeys: selectedMrLineKeys,
    onChange: (selectedMrLineKeys) => {
      //onTabChange(selectedMrLineKeys[0]);
      handleTabChange(selectedMrLineKeys[0]);
    },
  };

  const getTabContent = (requestedLines) => {
    let tabPanes = [];
    requestedLines.forEach((line, index) => {
      if (
        line.requestedItemsByPallets &&
        line.requestedItemsByPallets.length > 0
      ) {
        tabPanes.push(
          <Tabs.TabPane
            tab={`${line.stockTypeObj && line.stockTypeObj.code} (${
              line.requestedItemsByPallets &&
              line.requestedItemsByPallets.length
            })`}
            key={line.key}
          >
            <Table
              bordered
              size="small"
              rowKey="id"
              columns={getStockItemColumns()}
              dataSource={line.requestedItemsByPallets}
              pagination={false}
              summary={(pageData) => {
                let totalQuantity = 0;
                let totalAssignQuantity = 0;

                pageData.forEach(({ totalItems, assignQuantity }) => {
                  totalQuantity += totalItems;
                  totalAssignQuantity += assignQuantity;
                });

                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={5}>
                        <Text strong>Total</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        <Text strong>
                          {line.requestedItemsByPallets.length}
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        <Text strong>{totalQuantity}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="right">
                        <Text strong>
                          {totalAssignQuantity && Number(totalAssignQuantity)}
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell />
                      <Table.Summary.Cell />
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </Tabs.TabPane>
        );
      }
    });

    return tabPanes;
  };

  const handleSearchAndAddStocks = (line) => {
    const stockTypeId = line.stockType.id;
    setSelectedStockTypeId(stockTypeId);
    setSelectedLineKey(line.key);
    handleTabChange(line.key);
    setEnableVerify(false);
    console.log("Enable: ", enableVerify);

    if (stockTypeId) {
      /* let requestLine = null;
            data.forEach((item) => {
              if (item.hasOwnProperty("lotNumber")) {
                if (
                  item.stockType === materialTypeId &&
                  item.lotNumber === lotNumberId
                ) {
                  requestLine = item;
                }
              } else if (item.stockType === materialTypeId) {
                requestLine = item;
              }
            }); */
      if (line.requestedItemsByPallets) {
        setSelectedStockIds(
          line.requestedItemsByPallets
            .filter((item) => ["AVAILABLE", "ALLOCATED"].includes(item.mode))
            .map((item) => item.id)
        );
        //console.log("SSI:", selectedStockIds);
        //selectedStockIds = line.requestedItems.map((item) => item.id);
      }
      getStorageUnits(stockTypeId);
    } else {
      message.error("Please select valid material type!");
    }
  };

  const getStorageUnits = (stockTypeId) => {
    //let searchParams = `?stockTypeId=${materialTypeId}&lotNumberId=${lotNumberId}&status=AVAILABLE&pageNumber=1&pageSize=100`;
    let searchParams = `?all=true&stockTypeIdStr=${stockTypeId}&modes=AVAILABLE`;

    setIsAvailableStocksLoading(true);
    storageUnitService
      .search(searchParams)
      .then((data) => {
        setIsAvailableStocksLoading(false);
        if (data.content.length > 0) {
          //console.log("Selected Items: ", selectedStockIds);
          //console.log("Stocks: ", data.content);
          const stocksWithAssignQuantity = data.content.map((stock) => ({
            ...stock,
            assignQuantity: stock.assignQuantity ?? stock.totalItems,
          }));
          setAvailableStocks(stocksWithAssignQuantity);
          setIsStockSelectionVisible(true);
          //setMaterialTypeId(stockTypeId);
          //setLotNumberId(lotId);
        } else {
          message.info(
            "Sorry, There's no available stocks for the given criteria!"
          );
        }
      })
      .catch((error) => {
        setIsAvailableStocksLoading(false);
        message.error(`${error}`);
      });
  };

  const handleStockSelection = (stockIds) => {
    setSelectedStockIds(stockIds);
  };

  const handleStockQuantityChange = (updatedStocks) => {
    setAvailableStocks(updatedStocks);
  };

  const handleAddStocks = () => {
    //console.log("Selected: ", selectedStockIds);
    let selectedStocks = availableStocks.filter((item) =>
      selectedStockIds.includes(item.id)
    );
    //console.log("MR: ", form.getFieldValue("requestLines"));
    setEnableVerify(true);
    setStockItemLoading(true);
    if (selectedStocks) {
      let requestLine;
      requestLine = form
        .getFieldValue("requestLines")
        .find(
          (line) =>
            line.id === activeTabKey &&
            line.stockType.id === selectedStockTypeId
        );
      /* if (selectedLotNumberId) {
        requestLine = form
          .getFieldValue("requestLines")
          .find(
            (line) =>
              line.id === activeTabKey &&
              line.stockType.id === selectedStockTypeId
          );
      } else {
        requestLine = form
          .getFieldValue("requestLines")
          .find(
            (line) =>
              line.id === activeTabKey &&
              line.stockType.id === selectedStockTypeId
          );
      } */
      const stockTypeObj = materialTypes.find(
        (item) => item.id === selectedStockTypeId
      );
      if (requestLine) {
        requestLine["stockTypeObj"] = stockTypeObj;
        requestLine["stockType"] = stockTypeObj;
        requestLine["requestedItemsByPallets"] = [
          ...(requestLine.requestedItemsByPallets ?? []).filter((item) =>
            ["ALLOCATED"].includes(item.mode)
          ),
          ...selectedStocks,
        ];
        //setAllocatedItems([...allocatedItems, ...selectedStocks]);
        setAllocatedItems([
          ...allocatedItems,
          ...selectedStocks.map((stock) => ({
            ...stock,
            requestedLine: requestLine,
          })),
        ]);
        /* requestLine["netWeight"] =
                    selectedStocks.length > 0 &&
                    selectedStocks
                        .map((item) => item.netWeight)
                        .reduce((prev, next) => prev + next); */
        /* requestLine["quantity"] =
          selectedStocks.length > 0 &&
          selectedStocks
            .map((item) => item.quantity)
            .reduce((prev, next) => prev + next); */

        setMaterialRequestLines(form.getFieldValue("requestLines"));
        materialRequest.requestLines = form.getFieldValue("requestLines");
        handleTabChange(requestLine.id);
      }
    }
    form.setFieldsValue({ stockType: null });
    setSelectedStockTypeId(null);
    setIsStockSelectionVisible(false);
    setStockItemLoading(false);
    setSelectedStockIds([]);
    //console.log("requestLines:", materialRequestLines);
  };

  const handleLineDelete = () => {
    setMaterialRequestLines(form.getFieldValue("requestLines"));
  };

  const handleTabChange = (activeKey) => {
    setActiveTabKey(activeKey.toString());
    setSelectedMrLineKeys([activeKey.toString()]);
    setActiveRequestLine(
      materialRequestLines.find((line) => line.key === activeKey)
    );
  };

  const getRequestStageColor = (orderStage) => {
    let color = "#87d068";
    if (orderStage === "OPEN") {
      color = "#2db7f5";
    } else if (["IN_PROGRESS", "ACCEPTED"].includes(orderStage)) {
      color = "#108ee9";
    } else if (orderStage === "VERIFICATION_INPROGRESS") {
      color = "#d4b106";
    }

    return color;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-requests">Material Request Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                {materialRequest.requestNumber} ::{" "}
                <Tag color={getRequestStageColor(materialRequest.orderStage)}>
                  {materialRequest.orderStage}
                </Tag>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <TabMenu menu="verify" id={id} status={materialRequest.orderStage} />
          <Spin tip="Loading..." spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["customer", "id"]}
                    label="Customer"
                    rules={[
                      { required: true, message: "Customer is required" },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      //onChange={getAddresses}
                    >
                      {customers.length > 0 &&
                        customers.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="contactPersonName"
                    label="Contact Person Name"
                    rules={[
                      {
                        required: true,
                        message: "Contact persion is required",
                      },
                    ]}
                  >
                    <Input placeholder="Contact persion" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="requestDate"
                    label="Request Date"
                    rules={[
                      { required: true, message: "Request date is required" },
                    ]}
                    initialValue={moment()}
                  >
                    <DatePicker
                      placeholder="Request date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["deliveryLocation", "id"]}
                    label="Deliver To"
                    rules={[
                      {
                        required: true,
                        message: "Delivery from is required",
                      },
                    ]}
                  >
                    <Select placeholder="Please select">
                      {addresses.length > 0 &&
                        addresses.map((t) => (
                          <Option value={t.id} key={t.id}>
                            {t.address}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="contactNumber"
                    label="Contact No:"
                    rules={[
                      { required: true, message: "Contact No. is required" },
                    ]}
                  >
                    <Input placeholder="Contact number" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="requestNumber" label="Request No">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="remark" label="Remark">
                    <TextArea />
                  </Form.Item>
                </Col>
              </Row>

              {materialRequest &&
                materialRequest.requestLines &&
                materialRequest.requestLines.length > 0 && (
                  <Table
                    bordered
                    columns={getLineColumns()}
                    dataSource={materialRequest.requestLines}
                    pagination={false}
                    rowClassName={(record) =>
                      ["VERIFIED", "COMPLETED"].includes(record.lineStage)
                        ? "ant-tag-green"
                        : ""
                    }
                    rowSelection={{
                      type: "radio",
                      ...mrLineRowSelection,
                    }}
                    size="small"
                    summary={getLineSummary}
                  />
                )}
            </Form>
            <Modal
              title={`Stocks (${
                availableStocks.length > 0 &&
                availableStocks
                  .map((item) => item.totalItems)
                  .reduce((prev, next) => prev + next)
              }) - Req. Quantity=${
                activeRequestLine && activeRequestLine.measurements
                  ? `[${activeRequestLine.measurements
                      .map(
                        (measurement) =>
                          `${measurement.measurementType.name}: ${measurement.measurementValue}`
                      )
                      .join(", ")}]`
                  : "-"
              }`}
              style={{ top: 48 }}
              visible={isStockSelectionVisible}
              okText={`Add Stocks (${selectedStockIds.length})`}
              onOk={handleAddStocks}
              onCancel={() => {
                setIsStockSelectionVisible(false);
                setSelectedStockIds([]);
              }}
              width={1300}
              destroyOnClose={true}
            >
              <StockSelection
                stocks={availableStocks}
                selectedIds={selectedStockIds}
                onSelectChange={handleStockSelection}
                onQuantityChange={handleStockQuantityChange}
              />
            </Modal>
            {materialRequestLines.length > 0 &&
              materialRequestLines.flatMap(
                (item) => item.requestedItemsByPallets
              ).length > 0 && (
                <>
                  <Divider orientation="left">Verified Stock Items</Divider>
                  <Tabs
                    onChange={handleTabChange}
                    activeKey={activeTabKey}
                    type="card"
                  >
                    {getTabContent(materialRequestLines)}
                  </Tabs>
                </>
              )}
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Verify;
